import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@cwos/ui-shared';
import { Icon } from '../icon/Icon';
import styles from './notes.module.css';
export function StalenessNote({ asOf, reason, unaffected, href = '/records', onNavigate, }) {
    return (_jsxs("div", { className: styles.staleness, role: "note", children: [_jsx(Icon, { name: "look", className: styles.stalenessIcon }), _jsxs("div", { className: styles.stalenessBody, children: [_jsxs("p", { children: [_jsx("span", { className: styles.asOf, children: t('delivery.asOf', { t: asOf }) }), ' · ', reason, ' ', _jsx("a", { href: href, onClick: (e) => {
                                    if (onNavigate) {
                                        e.preventDefault();
                                        onNavigate(href);
                                    }
                                }, children: t('sync.intact') })] }), unaffected ? _jsx("p", { className: styles.unaffected, children: unaffected }) : null] })] }));
}
//# sourceMappingURL=StalenessNote.js.map